module.exports = __webpack_public_path__ + "static/img/BOE.0114abd5.png";